import {
  ArrowRight,
  Check,
  Clock,
  FileText,
  Info,
  Phone,
  Plus,
  ShieldCheck,
  Sparkles,
  TriangleAlert,
  Truck,
  User,
  Wrench,
} from 'lucide-react'

import { Cap, Demo, DsSection } from '../primitives'

const ICONS = [
  { name: 'truck', Icon: Truck },
  { name: 'shield-check', Icon: ShieldCheck },
  { name: 'file-text', Icon: FileText },
  { name: 'phone', Icon: Phone },
  { name: 'clock', Icon: Clock },
  { name: 'check', Icon: Check },
  { name: 'plus', Icon: Plus },
  { name: 'arrow-right', Icon: ArrowRight },
  { name: 'user', Icon: User },
  { name: 'info', Icon: Info },
  { name: 'triangle-alert', Icon: TriangleAlert },
  { name: 'wrench', Icon: Wrench },
  { name: 'sparkles', Icon: Sparkles },
]

export function IconsSection() {
  return (
    <DsSection id="icons" title="Icons" marketing>
      <Demo label="Core set · 16×16 · stroke 2">
        <div className="flex flex-wrap gap-x-8 gap-y-6">
          {ICONS.map(({ name, Icon }) => (
            <div key={name} className="text-ink-700 flex w-20 flex-col items-center gap-2">
              <Icon size={16} />
              <Cap className="text-center">{name}</Cap>
            </div>
          ))}
        </div>
      </Demo>
      <Demo label="Color by context">
        <div className="flex flex-wrap items-center gap-10">
          <div className="text-brand-800 flex items-center gap-2">
            <ShieldCheck size={16} />
            <Cap className="text-ink-500">value prop · brand-800</Cap>
          </div>
          <div className="text-brand-600 flex items-center gap-2">
            <Check size={16} />
            <Cap className="text-ink-500">checklist mark · brand-600</Cap>
          </div>
          <div className="text-accent-green flex items-center gap-2">
            <Check size={16} />
            <Cap className="text-ink-500">status ok · --green</Cap>
          </div>
          <div className="flex items-center gap-2 text-(--amber)">
            <Clock size={16} />
            <Cap className="text-ink-500">status watch · --amber</Cap>
          </div>
        </div>
      </Demo>
    </DsSection>
  )
}
